module.exports = __webpack_public_path__ + "img/姜半夏.4f4a59b9.jpg";